<template lang="pug">
  v-sheet(class="category-container")
    h3.header-title Categories
    v-progress-circular(
      v-if="loading"
      indeterminate
      color="primary"
      :size="100"
    )
    h6(v-else-if="!category_list.length") Nothing avaiable yet.
    v-slide-group(
      v-else
      v-model="selected"
      center-active
      mobile-breakpoint="1264"
    )
      v-slide-item(
        v-for="(c, index) in category_list"
        :key="c.business_id"
        v-slot="{ active, toggle }"
      )
        v-card(
          :color="active ? 'primary lighten-1' : 'white'"
          class="mt-0 ml-0 ma-4 text-center category-item"
          height="100"
          width="100"
          @click="toggle(); switchCategory(c)"
        )
          img(
            class="p-3"
            height="80"
            width="80"
            :src="c.business_imageurl"
          )
          b.m-auto.text-center {{ c.business_name }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  watch: {
    type() {
      this.getBusinessList();
    }
  },
  data() {
    return {
      category_list: [],
      selected: 0,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    type() {
      return this.$store.getters.businessType;
    }
  },
  mounted() {
    this.getBusinessList();
  },
  methods: {
    switchCategory(item) {
      this.$emit("switchCategory", item.business_id);
    },
    getBusinessList() {
      let url = config.businessUrl();

      var json = {
        params: {
          business_type: this.type,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.category_list = [
                  {
                    business_id: "",
                    business_name: "All",
                    business_imageurl:
                      "https://png.pngtree.com/png-vector/20190120/ourlarge/pngtree-menu-vector-icon-png-image_470444.jpg"
                  }
                ].concat(response.body.data);
              } else {
                this.$swal(
                  this.$t("error.get_business_list"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_business_list"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_business_list"),
            response.body.message,
            "error"
          );
        });
    }
  }
};
</script>
